import React, { useCallback, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styles from './PlansSectionProp103.module.css';
import { UpgradePlanCard } from './UpgradePlanCard';
import { useCalculatePlanPrice, useVisibilityObserver } from '../../../hooks';
import { DeductibleReimbursement } from '../customPlan/DeductibleReimbursement';
import { changeProp103PlanType } from '../../../actions';

const UpgradePlanDot = ({ title, targetId }) => {
  const { t } = useTranslation('quoting');
  const targetRef = useRef();

  useEffect(() => {
    // find the component on the dom
    targetRef.current = document.getElementById(targetId);
  }, [targetId]);

  const isVisible = useVisibilityObserver(targetRef, 0.5);

  const handleClick = useCallback(() => {
    const target = document.getElementById(targetId);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start',
      });
    }
  }, [targetId]);

  return (
    <button
      aria-label={t('prop103.scrollTo', { name: title })}
      className={`${styles.upgradeDot} ${isVisible
        ? styles.upgradeDotActive : ''}`}
      onClick={handleClick}
      type="button"
    />
  );
};

export const PlansSectionProp103 = () => {
  const { t } = useTranslation('quoting');
  const {
    getPlanTypePrice,
    plans,
    planTypeInfo,
    quoteSelected,
  } = useCalculatePlanPrice();
  const dispatch = useDispatch();

  const handleUpgradeClick = useCallback((id) => () => {
    dispatch(changeProp103PlanType(id));
  }, [dispatch]);

  return (
    <>
      <p className="Card-plan-main-text">
        {t('prop103.planSectionDesc', { petName: quoteSelected?.petName })}
      </p>

      <div className={styles.upgradesContainer}>
        {planTypeInfo.map((up) => (
          <UpgradePlanCard
            key={up.id}
            coveredItems={up.coveredItems}
            description={up.description}
            icon={up.icon}
            id={`upgrade-${up.id}`}
            isSelected={up.id === quoteSelected?.prop103PlanType}
            monthly={up.monthly}
            onClick={handleUpgradeClick(up.id)}
            plans={plans}
            price={getPlanTypePrice(up.id)}
            quoteSelected={quoteSelected}
            title={up.title}
          />
        ))}
      </div>

      <div className={styles.upgradesDots}>
        {planTypeInfo.map((up) => (
          <UpgradePlanDot
            key={up.id}
            targetId={`upgrade-${up.id}`}
            title={up.title}
          />
        ))}
      </div>

      <div className={styles.desktopSelectors}>
        <DeductibleReimbursement
          plans={plans}
          quoteSelected={quoteSelected}
        />
      </div>
    </>
  );
};
